export const DEFAULT_LEAD_SOURCE = 'Direct';

export const FALLBACK_LEAD_SOURCE_OPTIONS = [
  'Indiamart',
  'Justdial',
  'Whatsapp',
  'Website',
  'Direct',
  'Nowfloats',
  'Reference',
];

export const toDropdownOptions = (sources: string[]) =>
  sources.map((source) => ({
    label: source,
    value: source,
  }));
